module.exports = __webpack_public_path__ + "media/images/flags/SS-d1e1de0e6b12fcdee5720b7422796b29.svg";